<base-index-page
    [config]="baseIndexPageConfig"
    [service]="qualityManagementService"
    [idKey]="'companyDocumentGroupId'"
    [subSectionSettings]="'deleteCompanyDocumentGroup'"
></base-index-page>
